import React, { useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";
import { Row, Col } from "react-bootstrap";
import { MdOutlineModeEditOutline, MdSupervisedUserCircle, MdAccountCircle } from "react-icons/md";
import CprData from "./cpr/CprData";
import Lead from "../../shared/Lead";
import Table from "../../shared/Table";
import * as API from "../../api";
import Loading from "../../shared/Loading";
import Select from "../../shared/Select";
import CprOrderRequest from "./cpr/CprOrderRequest";
import TextArea from "../../shared/TextArea";
import Patient from "../../shared/Patient";
import LastMeasurementForm from "../forms/LastMeasurementForm";
import LastMeasuredQmsTable from "./LastMeasuredQmsTable";
import * as CONST from "../../helpers/Constants";

const OrderRequestTask = ({ task, dispatch, isCall, formHandler }) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [localTask, setLocalTask] = React.useState(task);

  // Keep in sync if parent sends a different task
  React.useEffect(() => {
    setLocalTask(task);
  }, [task]);

  const initialPromptVal = React.useMemo(() => {
    const val = localTask?.latest_quality_measurement;
    if (val === null || val === undefined) return null;
    return val === true ? "1" : "2";
  }, [localTask]);

  const [promptVal, setPromptVal] = React.useState(initialPromptVal);

  let [showDataEntry, setShowDataEntry] = React.useState(
    localTask.cpr.status == 'closed' &&
    localTask.cpr.procedure_type == 'Annual Wellness Visit'
  );

  return (
    <>
      <h1>Care Plan Requirement (CPR) - Order Request</h1>
      <div>
        <Row>
          <Col sm={4} md={3} className="cpr-data">
            <CprData
              data={{
                ...localTask.cpr,
                task: localTask,
                taskId: localTask.id,
                formHandler: (req) => localTask.formHandler(req),
              }}
            />
          </Col>
          <Col sm={8} md={9}>
            <div className={'m-t-lg'}>
              <p>
                We reviewed this patient's chart on { localTask.created_at_string } and determined they had not completed a <b>{ localTask.cpr.procedure_type }</b> within the required timeframe under our quality program.
                Therefore, we requested an order to help the patient complete the requirement.
              </p>
              <p>
                Before providing an order, please review the patient's chart again to ensure we have the most recent measurement for this patient, which determines their next due date. According to our records, this patient's last <b>{ localTask.cpr.procedure_type }</b> was completed on:
              </p>
              <div className="pt pb2 m-t-lg">
                {!!localTask.cpr.last_measured_quality_measurements.length > 0 ? (
                  <LastMeasuredQmsTable task={localTask} />
                ) : (
                  <b>NO RECORD FOUND</b>
                )}
              </div>
            </div>
            {

            }
            <p>{CONST.QM_STATUS_CHECK.BODY_2}</p>
            <b>{CONST.QM_STATUS_CHECK.FORM.PROMPT}</b>
            <br />
            <select
              id="cpr-status-check"
              className="cpr-form"
              placeholder="Select an option"
              disabled={task.status == 'closed'}
              value={promptVal}
              onChange={(e) => {
                setPromptVal(e.target.value);
                let latestQualityMeasurementValue = e.target.value == "1";

                if (latestQualityMeasurementValue) {
                  API.updateTask(localTask.id, {
                    task: {
                      id: localTask.id,
                      reset_order_document_verified: true
                    }
                  }).then((response) => {
                    setLocalTask((prev) => ({
                      ...prev,
                      cpr: {
                        ...prev.cpr,
                        order_document_verified: null,
                      },
                    }));
                  }).catch((err) => {
                    console.error("Failed to update task:", err);
                  });
                }
              }}
            >
              {!promptVal && <option>Select an option</option>}
              {CONST.QM_STATUS_CHECK.FORM.OPTIONS.map((i) => (
                <option value={i.value} key={i.value}>
                  {i.label}
                </option>
              ))}
            </select>
            {((promptVal == "1") || (localTask.latest_quality_measurement == true && localTask.status == 'closed')) &&
                (<CprOrderRequest
                task={{
                  ...localTask,
                }}
              />)
            }

            {((promptVal == "2") || (localTask.latest_quality_measurement == false && localTask.status == 'closed')) && (
              <>
                <b>{CONST.QM_STATUS_CHECK.SELECTED_VALUE_2} </b>
                <LastMeasurementForm showDataEntry={showDataEntry} setShowDataEntry={setShowDataEntry} task={localTask}/>
              </>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};

export default OrderRequestTask;
